import React, { ReactNode } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

interface PortalPageProps {
  children?: ReactNode;
}

function PortalPage({ children }: PortalPageProps) {
  return (
    <>
      <Container>
        <Grid container>
          <Grid item xs>
            {children}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default PortalPage;
